import { Base64 } from 'js-base64';

export const parseJwt = (token: string) => {
  try {
    const splitToken = token.split('.')[1];
    const decodedBase64 = Base64.decode(splitToken);
    return JSON.parse(decodedBase64);
  } catch (e) {
    console.error(`Error parsing token ${token}, error: ${JSON.stringify(e)}`);
    return null;
  }
};

export const isValidToken = (token: string) => {
  const decodedToken = parseJwt(token);

  if (decodedToken && decodedToken.exp) {
    return decodedToken.exp < Date.now();
  }
  return false;
};
